/* global process */

import { configureStore } from '@reduxjs/toolkit';
import { articlesApi } from './api/articlesApi';
import reducers from './reducers';

export default (preloadedState = undefined) => {
  return configureStore({
    reducer: reducers,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(articlesApi.middleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
};
